module.exports = __webpack_public_path__ + "static/media/user.b2e85f29.svg";